import { render, staticRenderFns } from "./DeviceMedias.vue?vue&type=template&id=f0bfd584&scoped=true&"
import script from "./DeviceMedias.vue?vue&type=script&lang=js&"
export * from "./DeviceMedias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bfd584",
  null
  
)

export default component.exports